<template>
  <b-form @submit.prevent="onSubmit">
    <b-row align-v="center">

      <form-group class="  col-lg-4" :validations="$v.form.name">
        <div slot-scope="{ errors, invalid }">
          <b-form-group label="نام">

            <b-form-input v-model="form.name"/>
            <form-errors-manager :errors="errors"/>

          </b-form-group>
        </div>
      </form-group>

      <form-group class="  col-lg-4" :validations="$v.form.slug">
        <div slot-scope="{ errors, invalid }">
          <b-form-group label="slug">

            <b-form-input v-model="form.slug"/>
            <form-errors-manager :errors="errors"/>

          </b-form-group>
        </div>
      </form-group>

      <form-group class="col-lg-4 text-right Font" :validations="$v.form.preview">
        <div slot-scope="{ errors, invalid }">


          <b-form-file
              browse-text="انتخاب عکس"
              @change="onFileChange"
              class="text-center"
              v-model="form.image"
              placeholder="انتخاب عکس"
              drop-placeholder="انتخاب عکس"
          ></b-form-file>

          <input id="brand-image" type="hidden" @change="onFileChange"/>

          <div id="preview" class="mt-2">
            <img alt="" v-if="form.preview" class="language-image" :src="form.preview"/>
          </div>

          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>


      <div class="col-lg-12 text-center">
        <b-btn class="px-5" pill type="submit">ثبت</b-btn>
      </div>

    </b-row>
  </b-form>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager";
import languageBox from "./LanguageBox";
import {required} from "vuelidate/lib/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";

export default {
  name: "LanguageForm",
  components: {FormGroup, FormErrorsManager, languageBox},
  props: {
    submitFunction: {},
    language: {
      default: null
    }
  },
  data() {
    return {
      form: {
        name: '',
        slug: '',
        image: [],
        type: 0,
        preview: '',
      },
    }
  },
  validations: {
    form: {
      name: {required},
      slug: {required, slug},
      preview: {},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.image = file;
      this.form.preview = URL.createObjectURL(file);
    },
    onSubmit() {
      if (this.invalid()) {
        const form = this.form
        this.submitFunction(form)
      }
    },
  },
  mounted() {
    if (this.language != null) {
      this.form = Object.assign({}, this.language)
      this.form.preview = this.language.image
      this.form.image = []
    }
  }
}
</script>

<style scoped>
.language-image {
  object-fit: contain;
  width: 50px;
  height: 50px;
}
</style>